import WsService from "services/WsService";
import User from "../../domain/User/User";

const ENDPOINT_BASE = "/admin/user";

export default class UserService {

  static retrieveManagedUsers(managerUserId) {
    let endpoint = ENDPOINT_BASE;
    endpoint = endpoint + "/" + managerUserId + "/managed-user";

    return WsService.get(endpoint, {}, 200).then(
      response => {
        let array = [];
        response.forEach(singleResponse => {
            array.push(new User(singleResponse));
        });
        return array;
      },
      response => {
        return response;
      }
    )
  }
}
